<script>
import vClickOutside from "v-click-outside";
import { computed } from "vue";
import store from "../vuex/store";
import Modal from "./shared/Modal/Modal.vue";
import InputWebsiteVue from "./shared/InputWebsite.vue";

const IMAGES_ENDPOINT = process.env.VUE_APP_IMAGES;

export default {
  components: { Modal, InputWebsiteVue },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  props: {
    items: Array,
    chooseWidget: Function,
    deleteWidget: Function,
    editWidget: Function,
    disabledList: Boolean
  },
  data() {
    return {
      chosen: computed(() => store.getters.getChosen),
      isOpen: false,
      confirmModalShown: false,
      widgetToDelete: null,
      widgetToEdit: null,
      editModalShown: false,
      widgetName: ""
    };
  },
  methods: {
    deleteModalOpen(e) {
      this.widgetToDelete = this.items.find(
        (item) => item.id == e.currentTarget.id
      );
      this.confirmModalShown = true;
      this.dropClose();
    },
    editModalOpen(id) {
      this.widgetToEdit = this.items.find(
        (item) => item.id == id
      );
      this.widgetName = this.widgetToEdit?.name;
      this.editModalShown = true;
      this.dropClose();
    },
    cencelEditing() {
      this.editModalShown = false;
      this.widgetToEdit = null;
    },
    confirmEditing() {
      this.editModalShown = false;
      this.editWidget(this.widgetToEdit.id, this.widgetName);
    },
    cencelDeleting() {
      this.confirmModalShown = false;
      this.widgetToDelete = null;
    },
    confirmDeleting() {
      this.confirmModalShown = false;
      this.deleteWidget(this.widgetToDelete.id);
    },
    dropOpen() {
      this.isOpen = !this.isOpen;
    },
    dropClose() {
      this.isOpen = false;
    },
    handleChoose(e) {
      const { id } = e.currentTarget;
      this.$props.chooseWidget(id);
      this.dropClose();
    },
  },
  computed: {
    imgLink() {
      if (!this.chosen) {
        return;
      }

      return typeof this.chosen?.settings?.botIcon === "string" &&
        this.chosen?.settings?.botIcon.length > 0 &&
        this.chosen?.settings?.botIcon !== "null"
        ? IMAGES_ENDPOINT + this.chosen?.settings?.botIcon
        : null;
    },
  },
};
</script>

<template>
  <div
    v-click-outside="dropClose"
    class="dropdownWrapper"
    :class="{'disabled_drop': disabledList}"
  >
    <div class="dropdownChoosen" @click="dropOpen">
      <div class="leftWrapper">
        <div v-if="imgLink" class="imgWrapper">
          <img
            v-if="chosen?.settings?.botIcon"
            class="chosenImg"
            :src="imgLink"
          />
        </div>
        <span class="chosenText">
          {{ chosen?.settings?.name || disabledList && 'No widgets created' || "Choose your widget" }}
        </span>
      </div>
      <svg class="dropSvg" :class="{ isOpen: isOpen }" width="14" height="8">
        <use href="../assets/icons/arrow-down.svg#arrow-down"></use>
      </svg>
    </div>
    <ul class="dropList" :class="{ isOpen: isOpen }">
      <li v-for="item of items" class="dropListItem">
        <button
          @click="handleChoose"
          :name="item.name"
          :id="item.id"
          class="dropListItemBtn"
        >
          <span>{{ item.name }}</span>
        </button>
        <button :id="item.id" @click="editModalOpen(item.id)" class="delete_btn mr-1">
          <svg class="delete_icon">
            <use href="../assets/icons/edit.svg#edit"></use>
          </svg>
        </button>
        <button :id="item.id" @click="deleteModalOpen" class="delete_btn">
          <svg class="delete_icon">
            <use href="../assets/icons/trash.svg#delete"></use>
          </svg>
        </button>
      </li>
    </ul>
    <Modal :isModalOpen="confirmModalShown" @close="cencelDeleting">
      <div slot="body" class="modal-content modal_body">
        <h5 class="modal-title">Confirm deleting</h5>
        <div class="modal-body-a">
          <p
            class="modal-body-delete__text"
            style="font-family: 'Inter', sans-serif"
          >
            Are you sure you want delete widget
            <span class="delete_name">{{ widgetToDelete?.name }}</span
            >?
          </p>
        </div>
        <div class="modal_footer">
          <button
            type="button"
            class="navbar_btn close_btn"
            @click="cencelDeleting"
          >
            Close
          </button>
          <button
            type="button"
            class="navbar_btn btn_delete danger"
            @click="confirmDeleting"
          >
            Confirm
          </button>
        </div>
      </div>
    </Modal>
    <Modal :isModalOpen="editModalShown" @close="cencelEditing">
      <div slot="body" class="modal-content modal_body">
        <h5 class="modal-title">Edit widget {{ widgetToEdit?.name }}</h5>
        <div class="modal-body-a">
          <InputWebsiteVue
            id="name"
            :className="{ empty_field: !widgetName }"
            placeholder="Enter widget name"
            v-model:value="widgetName"
            minlength="3"
          />
        </div>
        <div class="modal_footer">
          <button
            type="button"
            class="navbar_btn close_btn"
            @click="cencelEditing"
          >
            Cancel
          </button>
          <button
            type="button"
            class="navbar_btn btn_edit danger"
            :disabled="!widgetName"
            @click="confirmEditing"
          >
            Edit
          </button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<style lang="scss" scoped>
.dropdownWrapper {
  position: relative;
  width: 80%;
  padding: 8px 10px 8px 8px;
  background-color: white;
  margin: 0 auto;
  margin-bottom: 16px;
  border-radius: 6px;
  border: 1px solid #e0e0e0;

  &.disabled_drop {
    pointer-events: none;
    opacity: 0.8;
  }
}

.dropdownChoosen {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  cursor: pointer;
}

.leftWrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}

.imgWrapper {
  position: relative;
  width: 24px;
  height: 24px;
  object-fit: cover;
  border-radius: 50%;
  overflow: hidden;
}

.chosenImg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

svg.dropSvg {
  width: 14px;
  height: 8px;
  stroke: #3056d3;
  transition: all 150ms linear;

  &.isOpen {
    transform: rotate(180deg);
  }
}

.chosenText {
  display: block;
  max-width: 155px;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dropList {
  display: none;
  position: absolute;
  top: 101%;
  left: 0;
  list-style: none;
  background-color: white;
  width: 100%;
  border-radius: 6px;
  border: 1px solid #e0e0e0;
  margin: 0;
  padding: 0 8px;

  &.isOpen {
    display: block;
  }
}

.dropListItem {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 0 5px 5px;
  transition: all 150ms linear;

  &:not(:last-child) {
    border-bottom: 1px solid #e0e0e0;
  }
}

.dropListItemBtn {
  width: 100%;
  text-align: left;
  font-family: inherit;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: inherit;
  border: none;
  outline: none;
  background-color: transparent;
  padding: 0;
  cursor: pointer;
  transition: all 150ms linear;

  & > span {
    margin: 0;
    padding: 0;
    display: block;
    max-width: 148px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &:hover,
  :focus {
    color: #3056d3;
  }
}

.chosenText {
  margin: 0;
}

.delete_btn {
  border: none;
  background: transparent;
  padding: 5px 0 5px 5px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  outline: none;

  &:hover {
    & > svg {
      fill: #3056d3;
    }
  }
}
.delete_icon {
  width: 16px;
  height: 16px;
  fill: #000;
  transition: all 150ms linear;
}

.modal_body {
  font-family: "Inter", sans-serif;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
  border: none;
}

.modal-body-a {
  padding: 32px 18px;
}

.modal-content {
  font-family: "Inter", sans-serif;
  background-color: transparent;
}

.modal-title {
  font-family: inherit;
  text-align: center;
  max-width: 280px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.delete_name {
  color: #eb5757;
}

.modal_footer {
  display: flex;
  justify-content: center !important;
  flex-wrap: wrap;
  gap: 10px;
}
.btn_delete {
  border: 1px solid #e74545;
  background-color: #fff !important;
  color: #e74545 !important;
}
.btn_delete:hover {
  background: #eb5757 !important;
  color: #fff !important;
}
.close_btn {
  border: 1px solid #4764d5;
  padding: 9px 20px !important;
  font-size: 16px !important;
  color: #4764d5 !important;
}
.close_btn:hover {
  background: #4764d5 !important;
  color: #fff !important;
}
.btn_delete,
.close_btn,
.btn_edit {
  font-family: inherit;
  font-size: 16px;
  line-height: 24px;
  outline: none;
  background: transparent;
  border-radius: 6px;
  padding: 10px;
  cursor: pointer;
  transition: all 150ms linear;

  &:disabled {
    cursor: default;
    opacity: 0.6;
  }
}

.btn_edit {
  padding: 9px 20px !important;
  border: 1px solid #219653 !important;
  background: #fff !important;
  color: #219653;
}

.btn_edit:hover {
  background: #219653 !important;
  color: #fff;
}
</style>
